import { render, staticRenderFns } from "./UsersWidget.vue?vue&type=template&id=3eee883d&scoped=true&lang=pug"
import script from "./UsersWidget.vue?vue&type=script&lang=js"
export * from "./UsersWidget.vue?vue&type=script&lang=js"
import style0 from "./UsersWidget.vue?vue&type=style&index=0&id=3eee883d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eee883d",
  null
  
)

export default component.exports